var _excluded = ["children", "ellipsis", "lines"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _readOnlyError(r) { throw new TypeError('"' + r + '" is read-only'); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable no-plusplus, no-continue, consistent-return */
// Based on https://github.com/One-com/react-truncate
// There are a few minor adjustments to make this component work, mainly around handling exceptions.
// If there are better text truncation options, we should definitely migrate.
import React, { Component } from 'react';
import PropTypes from 'prop-types';
var styles = {
  ellipsis: {
    position: 'fixed',
    visibility: 'hidden',
    top: 0,
    left: 0
  }
};
var Truncate = /*#__PURE__*/function (_Component) {
  function Truncate() {
    var _this;
    _classCallCheck(this, Truncate);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Truncate, [].concat(args));
    _defineProperty(_this, "state", {});
    _this.elements = {};
    _this.onResize = _this.onResize.bind(_this);
    _this.onTruncate = _this.onTruncate.bind(_this);
    _this.calcTargetWidth = _this.calcTargetWidth.bind(_this);
    _this.measureWidth = _this.measureWidth.bind(_this);
    _this.getLines = _this.getLines.bind(_this);
    _this.renderLine = _this.renderLine.bind(_this);
    return _this;
  }
  _inherits(Truncate, _Component);
  return _createClass(Truncate, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var text = this.elements.text,
        calcTargetWidth = this.calcTargetWidth,
        onResize = this.onResize;
      var canvas = document.createElement('canvas');
      this.canvasContext = canvas.getContext('2d');
      calcTargetWidth(function () {
        // Node not needed in document tree to read its content
        if (text && text.parentNode) {
          text.parentNode.removeChild(text);
        }
      });
      window.addEventListener('resize', onResize);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // Render was based on outdated refs and needs to be rerun
      if (this.props.children !== prevProps.children) {
        this.forceUpdate();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var ellipsis = this.elements.ellipsis,
        onResize = this.onResize,
        timeout = this.timeout;
      if (ellipsis && ellipsis.parentNode) {
        ellipsis.parentNode.removeChild(ellipsis);
      }
      window.removeEventListener('resize', onResize);
      if (window.cancelAnimationFrame) {
        window.cancelAnimationFrame(timeout);
      }
    }
  }, {
    key: "onResize",
    value: function onResize() {
      this.calcTargetWidth();
    }
  }, {
    key: "onTruncate",
    value: function onTruncate(didTruncate) {
      var onTruncate = this.props.onTruncate;
      if (typeof onTruncate === 'function') {
        this.timeout = window.requestAnimationFrame(function () {
          onTruncate(didTruncate);
        });
      }
    }
  }, {
    key: "getLines",
    value: function getLines() {
      var elements = this.elements,
        _this$props = this.props,
        numLines = _this$props.lines,
        ellipsis = _this$props.ellipsis,
        trimWhitespace = _this$props.trimWhitespace,
        targetWidth = this.state.targetWidth,
        innerText = this.innerText,
        measureWidth = this.measureWidth,
        onTruncate = this.onTruncate,
        trimRight = this.trimRight;
      var lines = [];
      var text = innerText(elements.text);
      var textLines = text.split('\n').map(function (line) {
        return line.split(' ');
      });
      var didTruncate = true;
      var ellipsisWidth = this.ellipsisWidth(this.elements.ellipsis);
      for (var line = 1; line <= numLines; line++) {
        var textWords = textLines[0];

        // Handle newline
        if (textWords.length === 0) {
          lines.push();
          textLines.shift();
          line--;
          continue;
        }
        var resultLine = textWords.join(' ');
        if (measureWidth(resultLine) <= targetWidth) {
          if (textLines.length === 1) {
            // Line is end of text and fits without truncating
            didTruncate = false;
            lines.push(resultLine);
            break;
          }
        }
        if (line === numLines) {
          // Binary search determining the longest possible line inluding truncate string
          var textRest = textWords.join(' ');
          var lower = 0;
          var upper = textRest.length - 1;
          while (lower <= upper) {
            var middle = Math.floor((lower + upper) / 2);
            var testLine = textRest.slice(0, middle + 1);
            if (measureWidth(testLine) + ellipsisWidth <= targetWidth) {
              lower = middle + 1;
            } else {
              upper = middle - 1;
            }
          }
          var lastLineText = textRest.slice(0, lower);
          if (trimWhitespace) {
            lastLineText = trimRight(lastLineText);

            // Remove blank lines from the end of text
            while (!lastLineText.length && lines.length) {
              var prevLine = lines.pop();
              lastLineText = trimRight(prevLine);
            }
          }
          resultLine = /*#__PURE__*/React.createElement("span", null, lastLineText, ellipsis);
        } else {
          // Binary search determining when the line breaks
          var _lower = 0;
          var _upper = textWords.length - 1;
          while (_lower <= _upper) {
            var _middle = Math.floor((_lower + _upper) / 2);
            var _testLine = textWords.slice(0, _middle + 1).join(' ');
            if (measureWidth(_testLine) <= targetWidth) {
              _lower = _middle + 1;
            } else {
              _upper = _middle - 1;
            }
          }

          // The first word of this line is too long to fit it
          if (_lower === 0) {
            // Jump to processing of last line
            line = numLines - 1;
            continue;
          }
          resultLine = textWords.slice(0, _lower).join(' ');
          textLines[0].splice(0, _lower);
        }
        lines.push(resultLine);
      }
      onTruncate(didTruncate);
      return lines;
    }

    // Shim innerText to consistently break lines at <br/> but not at \n
  }, {
    key: "innerText",
    value: function innerText(node) {
      var div = document.createElement('div');
      var contentKey = 'innerText' in window.HTMLElement.prototype ? 'innerText' : 'textContent';
      div.innerHTML = node.innerHTML.replace(/\r\n|\r|\n/g, ' ');
      var text = div[contentKey];
      var test = document.createElement('div');
      test.innerHTML = 'foo<br/>bar';
      if (test[contentKey].replace(/\r\n|\r/g, '\n') !== 'foo\nbar') {
        div.innerHTML = div.innerHTML.replace(/<br.*?[/]?>/gi, '\n');
        text = div[contentKey];
      }
      return text;
    }
  }, {
    key: "calcTargetWidth",
    value: function calcTargetWidth(callback) {
      var target = this.elements.target,
        calcTargetWidth = this.calcTargetWidth,
        canvasContext = this.canvasContext;

      // Calculation is no longer relevant, since node has been removed
      if (!target) {
        return;
      }

      // Floor the result to deal with browser subpixel precision
      var elm = target && target.parentNode || target;
      var targetWidth = Math.floor(elm.getBoundingClientRect().width);

      // Delay calculation until parent node is inserted to the document
      // Mounting order in React is ChildComponent, ParentComponent
      if (!targetWidth) {
        return window.requestAnimationFrame(function () {
          return calcTargetWidth(callback);
        });
      }
      var style = window.getComputedStyle(target);
      var font = [style['font-weight'], style['font-style'], style['font-size'], style['font-family']].join(' ');
      canvasContext.font = font;
      this.setState({
        targetWidth: targetWidth
      }, callback);
    }
  }, {
    key: "measureWidth",
    value: function measureWidth(text) {
      return this.canvasContext.measureText(text).width;
    }
  }, {
    key: "ellipsisWidth",
    value: function ellipsisWidth(node) {
      return node.offsetWidth;
    }
  }, {
    key: "trimRight",
    value: function trimRight(text) {
      return text.replace(/\s+$/, '');
    }
  }, {
    key: "renderLine",
    value: function renderLine(line, i, arr) {
      if (i === arr.length - 1) {
        return /*#__PURE__*/React.createElement("span", {
          key: i
        }, line);
      } else {
        var br = /*#__PURE__*/React.createElement("br", {
          key: i + 'br'
        });
        if (line) {
          return [/*#__PURE__*/React.createElement("span", {
            key: i
          }, line), br];
        } else {
          return br;
        }
      }
    }
  }, {
    key: "renderChildren",
    value: function renderChildren() {
      var _this2 = this;
      var _this$props2 = this.props,
        tag = _this$props2.tag,
        children = _this$props2.children;
      var ChildrenWrapperTag = tag;
      return /*#__PURE__*/React.createElement(ChildrenWrapperTag, {
        ref: function ref(textEl) {
          _this2.elements.text = textEl;
        }
      }, children);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var target = this.elements.target,
        _this$props3 = this.props,
        children = _this$props3.children,
        ellipsis = _this$props3.ellipsis,
        lines = _this$props3.lines,
        spanProps = _objectWithoutProperties(_this$props3, _excluded),
        targetWidth = this.state.targetWidth,
        getLines = this.getLines,
        renderLine = this.renderLine,
        onTruncate = this.onTruncate;
      var text;
      var mounted = !!(target && targetWidth);
      if (typeof window !== 'undefined' && mounted) {
        if (lines > 0) {
          text = getLines().map(renderLine);
        } else {
          text = children;
          onTruncate(false);
        }
      }
      delete spanProps.onTruncate;
      delete spanProps.trimWhitespace;
      delete spanProps.tag;
      return /*#__PURE__*/React.createElement("span", _extends({}, spanProps, {
        ref: function ref(targetEl) {
          _this3.elements.target = targetEl;
        }
      }), /*#__PURE__*/React.createElement("span", null, text), this.renderChildren(), /*#__PURE__*/React.createElement("span", {
        ref: function ref(ellipsisEl) {
          _this3.elements.ellipsis = ellipsisEl;
        },
        style: styles.ellipsis
      }, ellipsis));
    }
  }]);
}(Component);
_defineProperty(Truncate, "propTypes", {
  tag: PropTypes.string,
  children: PropTypes.node,
  ellipsis: PropTypes.node,
  lines: PropTypes.oneOfType([PropTypes.oneOf([false]), PropTypes.number]),
  trimWhitespace: PropTypes.bool,
  onTruncate: PropTypes.func
});
_defineProperty(Truncate, "defaultProps", {
  tag: 'span',
  children: '',
  ellipsis: '…',
  lines: 1,
  trimWhitespace: false
});
export { Truncate as default };